import { Link, useLocation } from "react-router-dom";

const Navbar = ({ onLogout }) => {
  const location = useLocation();
  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  return (
    <div className="emp-navbar">
      <div className="emp-navbar-left">
        <div className="emp-nav-logo-wrap">
          <img
            src="/logo.png"
            alt="QDesk logo"
            className="emp-nav-logo"
          />
        </div>
        <div className="emp-nav-brand">
          <span className="emp-nav-title">QDesk</span>
          <span className="emp-nav-subtitle">Employee Portal</span>
        </div>
      </div>

      <div className="emp-navbar-right">
        <Link to="/dashboard" className={`emp-nav-link ${isActive("/dashboard") ? "active" : ""}`}>
          <span className="emp-nav-icon">🏠</span>
          <span>Dashboard</span>
        </Link>
        <Link to="/daily-sheet" className={`emp-nav-link ${isActive("/daily-sheet") ? "active" : ""}`}>
          <span className="emp-nav-icon">📅</span>
          <span>Daily Sheet</span>
        </Link>
        <Link to="/holidays" className={`emp-nav-link ${isActive("/holidays") ? "active" : ""}`}>
          <span className="emp-nav-icon">🎉</span>
          <span>Holidays</span>
        </Link>
        <Link to="/payslips" className={`emp-nav-link ${isActive("/payslips") ? "active" : ""}`}>
          <span className="emp-nav-icon">🧾</span>
          <span>Payslips</span>
        </Link>
        <Link to="/change-password" className={`emp-nav-link ${isActive("/change-password") ? "active" : ""}`}>
          <span className="emp-nav-icon">🔒</span>
          <span>Change Password</span>
        </Link>

        <button className="btn-secondary" onClick={onLogout}>
            Logout
        </button>
        </div>

      <div className="emp-navbar-footer">
        <span>© Quantumnique Solutions Private Limited</span>
      </div>
    </div>
  );
};

export default Navbar;
